import * as React from "react";
import classnames from "classnames";
import Button from "../../Button/Button/Button.js";
/* empty css                  */
const FilterButton = ({ caption, isSelected, ...buttonProps }) => /* @__PURE__ */ React.createElement(
  Button,
  {
    className: classnames("filter-button", {
      "filter-button--is-selected": isSelected,
      "filter-button--is-deselected": !isSelected
    }),
    caption,
    ...buttonProps
  }
);
export {
  FilterButton as default
};
//# sourceMappingURL=FilterButton.js.map
